export function createItem(item) {
  if( typeof item === "object" && item.id)
  {
    return item;
  }
  return {
    id: crypto.randomUUID(),
    text:item,
    done: false,
  };
}

export function moveArrayItem(arr, from, to) {
  if (to < 0 || to >= arr.length) return arr;

  const copy = [...arr];
  const item = copy.splice(from, 1)[0];
  copy.splice(to, 0, item);

  return copy;
}